<div class="d-flex flex-column justify-content-center align-items-center mt-3">
    <p class="text-center">The page you are looking for is not available.</p>
</div>
